import axios from 'axios';
import { ApiRoutes } from '../routes/routeConstants/apiRoutes';
import { AuthRoutes } from '../routes/routeConstants/appRoutes';
import { LocalStorageKeys } from '../enums/localStorageKeys';
import Notification, { destroyAllNotifications, suppressNotifications } from '../shared/components/Notification';
import { NotificationTypes } from '../enums/notificationTypes';
import { PlacementPosition } from '../enums/placementEnums';

const axiosInstance = axios.create({
  baseURL: ApiRoutes.API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

// Read token fresh on every request so it reflects login/logout without a page reload
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(LocalStorageKeys.AUTH_TOKEN);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Guards duplicate handling when several requests 401 at once; redirect is
// tied to the notification's onClose, not a timer, so it can't outrace it.
let isSessionExpired = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes(AuthRoutes.AUTH) && !isSessionExpired) {
      isSessionExpired = true;
      localStorage.removeItem(LocalStorageKeys.AUTH_TOKEN);
      localStorage.removeItem(LocalStorageKeys.USER);
      localStorage.removeItem(LocalStorageKeys.SELECTED_CLIENT);
      destroyAllNotifications();
      Notification({
        message: 'Session expired!',
        description: 'Your session has expired. Please log in again.',
        type: NotificationTypes.WARNING,
        duration: 3,
        placement: PlacementPosition.TOP,
        onClose: () => {
          window.location.href = AuthRoutes.LOGIN;
        },
      });
      suppressNotifications();
    }
    return Promise.reject(error);
  },
);

export const axiosGeoserverInstance = axios.create({
  baseURL: ApiRoutes.GEOSERVER_BASE_URL,
  timeout: 20000,
  auth: {
    username: import.meta.env.VITE_APP_CESIUM_USERNAME,
    password: import.meta.env.VITE_APP_CESIUM_PASSWORD,
  },
});

export default axiosInstance;
